<template>
    <div class="ticket_details">
        <div v-if="loading" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 80%;display: flex;justify-content: center;align-items: center;">
          <van-loading size="35" color="#de5d0a" />
        </div>
        <div v-for="getData in info" :key="getData.id">
            <div class="ticket_details_cart">
                <div class="tic_text" :class="{langKh: addFontKhmer}">{{$t('message.ticketCode')}}</div>
                <div class="tic_code">{{getData.code}}</div>
                <div style="padding-top: 20px;">
                    <div class="booked_date">
                        <div class="booked" :class="{langKh: addFontKhmer}">{{$t('message.bookedDate')}}</div>
                        <div class="date">{{getData.bookingDate}}</div>
                    </div>
                    <div class="depart_date">
                        <div class="de_date" :class="{langKh: addFontKhmer}">{{$t('message.departureDates')}}</div>
                        <div class="date">{{getData.travelDate}}</div>
                    </div>
                    <div class="destion">
                        <div class="de_from">{{getData.destinationFrom}}</div>
                        <div class="de_to">{{getData.destinationTo}}</div>
                    </div>
                    <div class="date_time">
                        <div class="de_time">{{getData.departure}}</div>
                        <div class="de_times">{{getData.arrival}}</div>
                    </div>
                    <div class="tran_type">
                        <div class="tran" :class="{langKh: addFontKhmer}">{{$t('message.transType')}}</div>
                        <div class="tran_vip">{{getData.transportationType}}</div>
                    </div>
                </div>
            </div>
            <div class="ticket_seat_number">
                <div class="num_price">
                    <div class="seat_numer" :class="{langKh: addFontKhmer}">{{$t('message.seatNumber')}}</div>
                    <div class="seat_pice" :class="{langKh: addFontKhmer}">{{$t('message.ticketPrice')}}</div>
                </div>
                <div class="male_price" v-for="seatN in getNaGenData" :key="seatN.id">
                    <div class="male" style="display: flex;">
                        <div style="width:20%">{{seatN.seatNumber}}</div>
                        <div style="width:80%">({{seatN.gender}})</div>
                    </div>
                    <div class="ma_price">{{seatN.price}} $</div>
                </div>
                <div class="sub_total">
                    <div class="total" :class="{langKh: addFontKhmer}">{{$t('message.subTotal')}}</div>
                    <div class="sub_price">{{getData.subTotal}}</div>
                </div>
                <div class="dis">
                    <div class="discount" :class="{langKh: addFontKhmer}">{{$t('message.discount')}}</div>
                    <div class="discount_price">{{getData.discount}}</div>
                </div>
                <div class="grand_total">
                    <div class="total" :class="{langKh: addFontKhmer}">{{$t('message.grandTotal')}}</div>
                    <div class="grand_price">{{getData.totalAmount}}</div>
                </div>
                <div class="qrcode">
                    <qrcode-vue :value="getData.code" :size="size" level="H" />
                </div>
            </div>
        </div>
        <div v-if="bookErrorIn">
            <div class="van-overlay" style="z-index: 2001;"></div>
            <div class="van-popup van-popup--center van-dialog van-dialog--round-button" role="dialog" tabindex="0" aria-labelledby="Information" style="z-index:2002;">
                <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information')}}</div>
                <div class="van-dialog__content">
                    <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.msgInternet')}}</div>
                </div>
                <div class="van-action-bar van-safe-area-bottom van-dialog__footer">
                    <button type="button" @click="closedBookError" class="van-button van-button--danger van-button--large van-action-bar-button van-action-bar-button--danger van-action-bar-button--last van-action-bar-button--first van-dialog__confirm">
                        <div class="van-button__content">
                            <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.ok')}}</span>
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import {Loading} from "vant";
import axios from 'axios';
export default {
    data() {
        return {
            url: localStorage.getItem("url"),
            bearer: localStorage.getItem("bearer"),
            addFontKhmer: false,
            onLine: navigator.onLine,
            loading: true,
            size: 125,
            info:[],
            bookErrorIn: false,
        }
    },
    methods: {
        closedBookError() {
            this.bookErrorIn = false;
            this.getDataBookingFind(localStorage.getItem('idbooking'));
        },
        goHome(){
            this.$router.push("/Home");
        },
        goShowTicket() {
            this.$router.push("/show-ticket");
        },
        async getDataBookingFind(id) {
            this.loading = true;
            const data = {
                'id': id,
            }
            const url = this.url +`booking/find/${id}`;
            let config = {
                method: "POST",
                headers: {
                    "Authorization": this.bearer,
                    "accept": "*/*",
                },
                data: JSON.stringify(data),
                url,
            };
            axios(config).then((response) => {
                this.loading = false;
                if(response.status == 200){
                    if(response.data.header.result == true && response.data.header.statusCode == 200) {
                        this.info = response.data.body.data;
                        this.getNaGen = response.data.body.data;
                        for (let i = 0; i<this.getNaGen.length; i++) {
                            this.start = this.getNaGen[i].departure;
                            this.end = this.getNaGen[i].duration;
                            this.getNaGenData = this.getNaGen[i].bookingSeatDetailList;
                        }
                    }
                }
            }).catch((error) => {
                this.bookErrorIn = true;
                console.log(error);
            });
        },
    },
    created() {
        this.$bridge.callHandler("setBarTitle", { title: "Ticket Detail", bgColor: "#de5d0a",color: "#ffffff"});

        if(this.$i18n.locale == "en") {
            this.addFontKhmer = false;
        }else {
            this.addFontKhmer = true;
        }

        if(!this.onLine) {
            this.bookErrorIn = true;
        }else{
            this.getDataBookingFind(localStorage.getItem('idbooking'));
        }
    },
    mounted() {
        window.onpopstate = () => {
            if(localStorage.getItem("reloadTicket") == 1) {
                setTimeout(() => {
                    this.goHome();
                }, 300);
            }else {
                setTimeout(() => {
                    this.goShowTicket();
                }, 300);
            }
        };
    },
    beforeUnmount() {
        window.onpopstate = null;
    },
    components: {
        QrcodeVue,
        [Loading.name]: Loading
    }
}
</script>

<style>
    .ticket_details {
       width: 100%;
    }
    .ticket_details .ticket_details_cart {
        width: 100%;
        padding: 15px 15px 40px 15px;
        border-bottom-left-radius: 35px;
        border-bottom-right-radius: 35px;
        background: #de5d0a;
    }
    .ticket_details .ticket_details_cart .tic_text {
        color: #FFF;
        font-weight: 500;
        text-align: center;
    }
    .ticket_details .ticket_details_cart .tic_code {
        color: #FFF;
        margin-top: 10px;
        font-weight: 500;
        text-align: center;
    }
    .ticket_details .ticket_details_cart .booked_date {
        margin-top: 5px;
        display: flex;
    }
    .ticket_details .ticket_details_cart .booked_date .booked{
        color: #FFF;
        font-weight: 500;
        width: 50%;
    }
    .ticket_details .ticket_details_cart .booked_date .date{
        color: #FFF;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_details .ticket_details_cart .depart_date {
        margin-top: 10px;
        display: flex;
    }
    .ticket_details .ticket_details_cart .depart_date .de_date{
        color: #FFF;
        font-weight: 500;
        width: 50%;
    }
    .ticket_details .ticket_details_cart .depart_date .date{
        color: #FFF;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_details .ticket_details_cart .destion {
        margin-top: 10px;
        display: flex;
    }
    .ticket_details .ticket_details_cart .destion .de_from{
        color: #FFF;
        font-weight: 500;
        width: 50%;
    }
    .ticket_details .ticket_details_cart .destion .de_to{
        color: #FFF;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_details .ticket_details_cart .date_time {
        margin-top: 10px;
        display: flex;
    }
    .ticket_details .ticket_details_cart .date_time .de_time{
        color: #FFF;
        font-weight: 500;
        width: 50%;
    }
    .ticket_details .ticket_details_cart .date_time .de_times{
        color: #FFF;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_details .ticket_details_cart .tran_type {
        color: #FFF;
        margin-top: 10px;
        display: flex;
    }
    .ticket_details .ticket_details_cart .tran_type .tran{
        font-weight: 500;
        width: 50%;
    }
    .ticket_details .ticket_details_cart .tran_type .tran_vip{
        color: #FFF;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_details .ticket_details_cart .tran_payment {
        color: #FFF;
        margin-top: 5px;
        display: flex;
    }
    .ticket_details .ticket_details_cart .tran_payment .tran_pay_ty{
        color: #FFF;
        font-weight: 500;
        width: 50%;
    }
    .ticket_details .ticket_details_cart .tran_payment .pay_aba{
        color: #FFF;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_seat_number {
        padding: 40px 15px 15px 15px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: -23px;
        background: #FFF;
    }
    .ticket_seat_number .num_price{
        margin-top: 5px;
        display: flex;
    }
    .ticket_seat_number .num_price .seat_numer{
        font-weight: 500;
        width: 50%;
    }
    .ticket_seat_number .num_price .seat_pice{
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_seat_number .male_price {
        margin-top: 5px;
        display: flex;
        padding-bottom: 5px;
        border-bottom: 1px solid gray;
    }
    .ticket_seat_number .male_price .male {
        color: #de5d0a;
        font-weight: 500;
        width: 50%;
    }
    .ticket_seat_number .male_price .ma_price {
        color: #de5d0a;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_seat_number .sub_total {
        margin-top: 5px;
        display: flex;
        padding-bottom: 5px;
        border-bottom: 1px solid gray;
    }
    .ticket_seat_number .sub_total .total {
        font-weight: 500;
        width: 50%;
    }
    .ticket_seat_number .sub_total .sub_price {
        color: #272795;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_seat_number .dis {
        margin-top: 5px;
        display: flex;
        padding-bottom: 5px;
        border-bottom: 1px solid gray;
    }
    .ticket_seat_number .dis .discount {
        font-weight: 500;
        width: 50%;
    }
    .ticket_seat_number .dis .discount_price {
        color: #272795;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_seat_number .grand_total {
        margin-top: 5px;
        display: flex;
        padding-bottom: 5px;
        border-bottom: 1px solid gray;
    }
    .ticket_seat_number .grand_total .total {
        font-weight: 500;
        width: 50%;
    }
    .ticket_seat_number .grand_total .grand_price {
        color: #272795;
        font-weight: 500;
        width: 50%;
        text-align: end;
    }
    .ticket_seat_number .qrcode {
        margin-top: 30px;
        text-align: center;
    }
</style>